import { render, staticRenderFns } from "./CurrentHomeInsurer.vue?vue&type=template&id=2efa43dc&"
import script from "./CurrentHomeInsurer.vue?vue&type=script&lang=js&"
export * from "./CurrentHomeInsurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports